import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { CustomerSupplierTypeService } from '../../services/customer-supplier-type.service';

@Component({
	selector: 'app-update-customer',
	templateUrl: './update-customer.component.html',
	styleUrls: ['./update-customer.component.css', '../../app.component.css']
})

export class UpdateCustomerComponent implements OnInit {

	customerForm: FormGroup;
	customer: any = [];

	subsidiaries = {};
	subsidiaryInit: any;
	subsidiaryText = '';
	
	customerSupplierSub: Subscription;
	subsidiarySub: Subscription;
	
	id: string;
	since: any = '';

	types: any[] = [];
	@Input() typeInit: string;
	@Output() modelChange = new EventEmitter();

	pickadateParams = Utils.pickadateParams();

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public customerSupplierService: CustomerSupplierService,
		private subsidiaryService: SubsidiaryService,
		private customerSupplierTypeService: CustomerSupplierTypeService
	) {
		this.id = activatedRoute.snapshot.paramMap.get('id');
		this.customerSupplierSub = this.customerSupplierService.getCustomerSupplier(this.id).subscribe(customerObj => {
			this.customer = customerObj;

			if (this.customer.clientSince) {
				this.since = Utils.convertDatefromStringtoISOString(this.customer.clientSince);
			}
			this.typeInit = this.customer.typeId;

			let underSub = this.subsidiaryService.getSubsidiary(this.customer.subsidiaryId).subscribe(subsidiaryObj => {
				this.subsidiaryText = subsidiaryObj.name;
				underSub.unsubscribe();
			});
			this.loadSubsidiariesAndTypes();
		});
	}

	ngOnInit() {
		this.customerForm = this.formBuilder.group({
			name: ['', Validators.required],
			initials: '',
			description: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			clientSince:  '',
			subsidiary: ['', Validators.required],
			type: ['', Validators.required],
			nextProduct: '',
			nextSuaje: '',
		});
	}
	ngOnDestroy() {
		this.customerSupplierSub.unsubscribe();
		this.subsidiarySub.unsubscribe();
	}

	onSubmitCustomer() {
		this.customer = this.saveCustomer();

		this.customerSupplierService.putCustomerSupplier(this.customer, this.id);
	}

	saveCustomer() {
		let clientSince: any;
		if (this.customerForm.get('clientSince').value) {
			clientSince = Utils.convertDatefromISOStringtoObject(this.customerForm.get('clientSince').value);
		} else {
			clientSince = '';
		}

		var initials = this.customerForm.get('initials').value.toUpperCase();
		initials = initials.length > 2 ? initials.charAt(0) + initials.charAt(1) : initials.length == 1 ? `0${initials}` : initials ? initials : '00';

		const customerJson = {
			clientSince: clientSince,
			description: this.customerForm.get('description').value,
			email: this.customerForm.get('email').value,
			name: this.customerForm.get('name').value,
			initials: initials,
			nextProduct: +this.customerForm.get('nextProduct').value || 0,
			nextSuaje: +this.customerForm.get('nextSuaje').value || 0,
			subsidiaryId: this.subsidiaries[this.customerForm.get('subsidiary').value],
			typeId: this.customerForm.get('type').value,
			updatedAt: new Date()
		};

		return customerJson;
}

loadSubsidiariesAndTypes() {
		this.subsidiarySub = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
			const data = {};

			for (const idx in tempSubsidiaries) {
				data[tempSubsidiaries[idx].name] = null;

				this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
			}

			this.subsidiaryInit = {
				'data': data,
				onAutocomplete: (val) => {
					// console.log(val);
					// console.log(this.subsidiaries[val]);
				}
			};
		});

		let subType = this.customerSupplierTypeService.getCustomerTypes().subscribe(tempTypes => {
			for (const idx in tempTypes) {
				this.types.push(tempTypes[idx]);
			}

			subType.unsubscribe();
		});
	}

	onBlurSubsidiary() {
		if (this.subsidiaries[this.subsidiaryText] === undefined) {
			this.subsidiaryText = '';
		}
	}

	changeType(typeValue) {
		this.modelChange.emit(typeValue);
	}

}
